<template>
  <div class="container">
    <!-- 地图页 -->
    <div class="container" v-show="selectedIndex === 0">
      <div id="map-container"></div>
      <!-- 深色和浅色模式切换 -->
      <div class="map-style-switcher">
        <el-popover  trigger="hover" placement="left" content="点击按钮，可切换地图风格">
         <!-- icon="el-icon-moon" -->
        <el-button slot="reference" v-if="isStandard" @click="setDarkStyle" class="bg-xiang" circle></el-button>
         <!-- icon="el-icon-sunny" -->
        <el-button slot="reference" v-else @click="setStandardStyle" class="bg-wen" circle></el-button>
        </el-popover>
      </div>
      <!-- 图层切换 -->
      <div class="polygon-style-switcher">
        <el-popover  trigger="hover" placement="left" content="点击按钮，可增减地图图层">
        <el-button slot="reference" v-if="isOpenPolygon" @click="setPolygonStyle" class="bg-kai" circle></el-button>
        <el-button slot="reference" v-else @click="setPolygonStyle" class="bg-guan" circle></el-button>
        </el-popover>
      </div>
      <!-- echarts统计 -->
      <div class="umbrella-style-switcher">
        <el-popover  trigger="hover" placement="left" content="尚在开发，敬请期待...">
        <el-button slot="reference" v-if="isOpensan" @click="setsanStyle" class="bg-zhang" circle></el-button>
        <el-button slot="reference" v-else @click="setsanStyle" class="bg-han" circle></el-button>
        </el-popover>
      </div>

      <!-- 地图控制按钮 -->
      <div class="map-controls">
        <el-popover trigger="hover" placement="left" content="回到初始位置">
          <el-button slot="reference" @click="resetMapView" icon="el-icon-refresh" circle></el-button>
        </el-popover>
      </div>
      
      <div class="map-zoom-controls">
        <el-popover trigger="hover" placement="left" content="放大地图">
          <el-button slot="reference" @click="zoomIn" icon="el-icon-plus" circle size="small"></el-button>
        </el-popover>
      </div>
      
      <div class="map-zoomout-controls">
        <el-popover trigger="hover" placement="left" content="缩小地图">
          <el-button slot="reference" @click="zoomOut" icon="el-icon-minus" circle size="small"></el-button>
        </el-popover>
      </div>
      
      <div class="map-fullscreen-controls">
        <el-popover trigger="hover" placement="left" content="全屏查看">
          <el-button slot="reference" @click="toggleFullscreen" icon="el-icon-full-screen" circle></el-button>
        </el-popover>
      </div>

      <div class="selectdiv">
        <!--按保护级别筛选-->
        <div class="protected">
          <span :class="{ 'moon-tag': !isStandard, 'sunny-tag': isStandard }">
            文保等级：</span>
          <br />
          <el-select v-model="queryBox.protected" @change="selectItem(2)" clearable>
            <el-option v-for="(item, index) in protectedList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <!--按照地区筛选-->
        <div class="area">
          <span :class="{ 'moon-tag': !isStandard, 'sunny-tag': isStandard }">
            行政区划：</span>
          <br />
          <el-select v-model="queryBox.area" @change="selectItem(1)" clearable>
            <el-option v-for="(item, index) in areaList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </div>
      </div>

      <!-- 文保级别 -->
      <div class="level">
        <div v-for="(item, index) in levelList" :key="index" @click="item.isChecked = !item.isChecked">
          <img class="level-img" style="width: 35px" :src="item.path"
            :class="{ isSelected: item.isChecked, unSelected: !item.isChecked }" />
          <span :class="{ 'moon-tag': !isStandard, 'sunny-tag': isStandard }">{{
            item.des
          }}</span>
        </div>
      </div>

      <!-- 遗址名字 -->
      <div class="search-group">
        <!-- h4大标题 -->
        <h4 class="title-container">
          <span :class="{ 'moon-title': !isStandard, 'sunny-title': isStandard }">
            <img v-if="isStandard" class="title-img" src="../assets/title.png" style="width:347px;height:45px" />
            <img v-else class="title-img" src="../assets/白色标题.png" style="width:347px;height:45px" />
          </span>
          <span class="icon">
            <el-popover placement="top-start" title="提示" width="200" trigger="hover" content="来自【梦熊太一】个人出品，侵权必究！">
              <p>❤本地图收集了第1-第8批全部的国家级旧石器古遗址，大部分省级旧石器遗址，小部分县市级旧石器遗址，有很多遗址级别不详暂列入未知</p>
              <p>❤遗址数据、经纬度、图片等信息，仅供参考</p>
              <p>❤欢迎补充更多遗址数据</p>
              <p>🐻来自【梦熊太一】个人出品，侵权必究！</p>
              <p>🍠号：梦熊太一</p>
              <p>🧉合作：ei13735587439</p>
              <strong>开发不易，求个赞赏↓</strong>
              <img src="../assets/赞赏.jpeg" style="width:200px" />
              <small>Version 3.0 2023-7-8</small>
              <i class="el-icon-info" slot="reference"></i>
            </el-popover>
          </span>
        </h4>
        
        <!-- 用户登录/收藏区域 -->
        <div class="user-actions">
          <div v-if="!isLoggedIn">
            <el-button size="small" type="primary" @click="openLoginDialog" icon="el-icon-user">登录</el-button>
            <el-button size="small" @click="openRegisterDialog" icon="el-icon-edit">注册</el-button>
          </div>
          <div v-else class="user-info">
            <el-dropdown @command="handleUserCommand">
              <span class="user-dropdown">
                <i class="el-icon-user-solid"></i>
                {{ currentUser.username }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="favorites">
                  <i class="el-icon-star-on"></i> 我的收藏 ({{ favorites.length }})
                </el-dropdown-item>
                <el-dropdown-item command="logout" divided>
                  <i class="el-icon-switch-button"></i> 退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        
        <div class="search-input-wrapper">
          <el-input 
            placeholder="可根据遗址名称、地理位置查询" 
            @keyup.enter.native="getDataByKeywords" 
            @input="onSearchInput"
            @focus="showHistory"
            v-model="keywords"
            clearable>
            <el-button slot="append" icon="el-icon-search" @click="getDataByKeywords"></el-button>
          </el-input>
          
          <!-- 搜索历史 -->
          <div class="search-dropdown" v-show="showSearchHistory">
            <div class="dropdown-header">
              <span>搜索历史</span>
              <el-button type="text" size="mini" @click="clearHistory">清空</el-button>
            </div>
            <div class="dropdown-item" v-for="(item, index) in searchHistory" :key="index">
              <span @click="selectHistory(item)" class="history-text">
                <i class="el-icon-time"></i> {{ item }}
              </span>
              <i class="el-icon-close" @click.stop="removeHistory(index)"></i>
            </div>
          </div>
          
          <!-- 自动补全 -->
          <div class="search-dropdown" v-show="showAutoComplete">
            <div class="dropdown-item" v-for="(item, index) in autoCompleteList" :key="index" @click="selectAutoComplete(item)">
              <div class="autocomplete-name">{{ item.name }}</div>
              <div class="autocomplete-addr"><small>{{ item.address }}</small></div>
            </div>
          </div>
        </div>
        <!-- 检索部分 -->
        <div class="data-group">
          <div class="result-header" @click="isResultsVisible = !isResultsVisible">
            <small v-if="filteredData.length > 0">
              <span class="result-count">共检索到相关遗址信息{{ displayCount }}条</span>
            </small>
            <small v-else>未检索到相关遗址信息</small>
            <i :class="isResultsVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="toggle-icon"></i>
          </div>
          <div class="list" v-show="isResultsVisible">
            <!-- 空状态 -->
            <div v-if="filteredData.length === 0" class="empty-state">
              <i class="el-icon-search empty-icon"></i>
              <p>没有找到相关遗址</p>
              <small>请尝试其他关键词</small>
            </div>
            <!-- 结果列表 -->
            <div v-else>
              <div v-for="(item, index) in paginatedData" :key="index">
                <div class="item" :class="{ active: activeIndex === index }">
                  <div class="info" @click="selectOne(item); activeIndex = index">
                    <div class="name">{{ item.name }}</div>
                    <div class="addr">
                      <small>{{ item.address }}</small>
                    </div>
                    <div class="time">{{ item.time }}</div>
                  </div>
                  <div class="item-actions">
                    <el-button 
                      size="mini" 
                      :type="isFavorite(item) ? 'warning' : 'default'"
                      :icon="isFavorite(item) ? 'el-icon-star-on' : 'el-icon-star-off'"
                      circle
                      @click.stop="toggleFavorite(item)"
                      :title="isFavorite(item) ? '取消收藏' : '收藏'">
                    </el-button>
                    <el-button 
                      size="mini" 
                      icon="el-icon-share"
                      circle
                      @click.stop="shareRelic(item)"
                      title="分享">
                    </el-button>
                  </div>
                </div>
              </div>
              <!-- 分页控件 -->
              <div class="pagination" v-if="totalPages > 1">
                <el-button size="mini" @click="prevPage" :disabled="currentPage === 1">
                  <i class="el-icon-arrow-left"></i>
                </el-button>
                <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
                <el-button size="mini" @click="nextPage" :disabled="currentPage === totalPages">
                  <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="isOpen">
      <div class="gallery" ref="gallery">
        <div class="flex-center">
          <div class="select">
            <div class="btn" v-for="(item,index) in option" :key="index" :class="currentIndex==index?'active':''" @click="changeIndex(index)">{{item}}</div>
          </div>
        </div>
        <div class="f12" style="
            border-radius: 5px;
            background-color: white;
            text-align: left;
            padding: 10px;
            overflow-x: hidden;
            max-height: 500px;
          " v-if="currentIndex == 0">
          <div>
            <div class="flex-y">
              <div class="flex-center left_fix">
                <img :src="tempImg.prop_jj" width="10px" height="20px" />
              </div>
              <div class="f16"><strong>简介</strong></div>
            </div>
            <div class="" style="margin:10px 5px">
              <img style="margin: auto; border-radius: 5px" :src="tempData.path || defaultImg" width="100%"
                height="200" />
            </div>
            <div class="flex-y mt5">
              <div class="flex-center left_fix">
                <img width="18px" height="18px" :src="tempImg.prop_name" />
              </div>
              <div class="f_600 f16">
                {{ tempData.name == null ? "" : tempData.name }}
              </div>
            </div>
            <div>
              <hr />
            </div>
            <div class="flex-y mt5">
              <div class="flex-center left_fix">
                <img width="18px" height="18px" :src="tempImg.prop_year" />
              </div>
              <div>
                <span class="f_600"></span>
                {{ tempData.era == null ? "" : tempData.era }}
              </div>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div class="flex-center left_fix">
                <img width="18px" height="18px" :src="tempImg.prop_wb" />
              </div>
              <div>
                <span class="f_600"></span>
                {{
                  tempData.protected_level == null
                    ? ""
                    : tempData.protected_level
                }}
              </div>
            </div>
            <div class="flex-y mt5">
              <div class="flex-center left_fix">
                <img width="18px" height="18px" :src="tempImg.prop_location" />
              </div>
              <div>
                {{ tempData.address == null ? "" : tempData.address }}
              </div>
            </div>
            <div class="flex mt5">
              <div class=" left_fix">
                <img width="18px" height="18px" :src="tempImg.prop_m" />
              </div>
              <div>
                <span class="f_600"></span>
                {{ tempData.standing == null ? "暂无" : tempData.standing}}
              </div>
            </div>
            <div class="flex mt5">
              <div class=" left_fix">
                <img width="16px" height="16px" :src="tempImg.prop_xz" />
              </div>
              <div>
                <span class="f_600"></span>
                {{ tempData.des == null ? "不详" : tempData.des }}
              </div>
            </div>
          </div>
        </div>

            <!-- border-radius: 5px;
            background-color: white;
            text-align: left;
            overflow-x: hidden;
            box-sizing: border-box;
            max-height: 500px; -->
        <div class="f12" style="
            border-radius: 5px;
            background-color: white;
            text-align: left;
            /* padding: 10px; */
            /* overflow-x: hidden; */
            width: 357px;
            max-height: 500px;
            overflow-y: auto;
          " v-if="currentIndex == 1">
          <div style="padding:10px;box-sizing: border-box;">
            <div>
                <div class="flex-y">
                  <div class="flex-center left_fix">
                    <img :src="tempImg.prop_jj" width="10px" height="20px" />
                  </div>
                  <div class="f16"><strong>画廊({{tempData.imgHualang.length}})</strong></div>
                </div>
              </div>
              <div class="mt10 flex-center" :class="tempData.imgHualang.length > 4 ? 'tc': ''">
                <div class="flex-center" style="width: 100%">
                  <div style="width: 100%">
                    <el-image v-for="(item, index) in tempData.imgHualang" :key="index" class="el-image" :src="item.path"></el-image>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 首次访问引导 -->
    <el-dialog
      title="欢迎使用史前时代·遗址地图"
      :visible.sync="showGuide"
      width="500px"
      center>
      <div class="guide-content">
        <h3>🗺️ 功能介绍</h3>
        <ul>
          <li><strong>搜索功能：</strong>支持遗址名称、地理位置搜索，带自动补全和搜索历史</li>
          <li><strong>筛选功能：</strong>可按行政区划、文保等级筛选遗址</li>
          <li><strong>地图控制：</strong>支持切换地图风格、图层、缩放、全屏等</li>
          <li><strong>遗址详情：</strong>点击地图标记查看遗址详细信息和图片</li>
        </ul>
        <h3>💡 小技巧</h3>
        <p>• 点击右侧图例可以显示/隐藏对应级别的遗址</p>
        <p>• 搜索框支持输入历史记录，方便再次查询</p>
        <p>• 结果列表支持折叠，点击顶部标题即可</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeGuide">开始使用</el-button>
      </span>
    </el-dialog>
    
    <!-- 登录对话框 -->
    <el-dialog
      title="用户登录"
      :visible.sync="showLoginDialog"
      width="400px"
      center>
      <el-form :model="loginForm" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="loginForm.username" placeholder="请输入用户名" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" @keyup.enter.native="handleLogin"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLoginDialog = false">取消</el-button>
        <el-button type="text" @click="openRegisterDialog">还没有账号？去注册</el-button>
        <el-button type="primary" @click="handleLogin">登录</el-button>
      </span>
    </el-dialog>

    <!-- 注册对话框 -->
    <el-dialog
      title="用户注册"
      :visible.sync="showRegisterDialog"
      width="400px"
      center>
      <el-form :model="registerForm" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="registerForm.username" placeholder="请输入用户名" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="registerForm.email" placeholder="请输入邮箱（选填）" prefix-icon="el-icon-message"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="registerForm.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="registerForm.confirmPassword" type="password" placeholder="请再次输入密码" prefix-icon="el-icon-lock" @keyup.enter.native="handleRegister"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRegisterDialog = false">取消</el-button>
        <el-button type="text" @click="showRegisterDialog = false; showLoginDialog = true">已有账号？去登录</el-button>
        <el-button type="primary" @click="handleRegister">注册</el-button>
      </span>
    </el-dialog>

    <!-- 收藏列表对话框 -->
    <el-dialog
      title="我的收藏"
      :visible.sync="showFavoritesDialog"
      width="600px">
      <div v-if="favorites.length === 0" class="empty-state">
        <i class="el-icon-star-off empty-icon"></i>
        <p>还没有收藏任何遗址</p>
        <small>快去收藏感兴趣的遗址吧</small>
      </div>
      <div v-else class="favorites-list">
        <div class="favorite-item" v-for="(item, index) in favorites" :key="index">
          <div class="fav-info" @click="selectFavorite(item)">
            <div class="fav-name">{{ item.name }}</div>
            <div class="fav-details">
              <small>{{ item.address }}</small>
              <el-tag size="mini" type="info" style="margin-left: 10px">{{ item.protected_level }}</el-tag>
            </div>
          </div>
          <div class="fav-actions">
            <el-button size="mini" type="primary" icon="el-icon-location" @click="selectFavorite(item)">定位</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="removeFavoriteFromList(item)">删除</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 分享对话框 -->
    <el-dialog
      title="分享遗址"
      :visible.sync="showShareDialog"
      width="450px"
      center>
      <div class="share-content" v-if="shareData">
        <h3>{{ shareData.name }}</h3>
        <p class="share-desc">{{ shareData.address }}</p>
        
        <div class="qrcode-container">
          <img :src="qrcodeUrl" alt="二维码" class="qrcode-img" />
          <p>扫描二维码查看遗址</p>
        </div>
        
        <div class="share-link">
          <el-input v-model="shareUrl" readonly>
            <el-button slot="append" icon="el-icon-document-copy" @click="copyShareLink">复制</el-button>
          </el-input>
        </div>
        
        <div class="share-buttons">
          <el-button type="primary" icon="el-icon-download" @click="downloadQRCode">下载二维码</el-button>
          <el-button icon="el-icon-share" @click="copyShareLink">复制链接</el-button>
        </div>
      </div>
    </el-dialog>
    
    <!-- #示例代码如下： -->
    <div class="flex" style="position: fixed;bottom: -3px;left:300px;z-index: 999999;;width:2000px;">
      <div><font size="1.5"><small :class="{ 'moon-tag': !isStandard, 'sunny-tag': isStandard }">© 2023 史前时代·遗址 </small></font>
        &nbsp&nbsp
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">
          <font size="1.5"><small :class="{ 'moon-tag': !isStandard, 'sunny-tag': isStandard }">浙ICP备2023014485号-1</small></font>
        </a>
      </div>
      <div style="margin-left:400px">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33030202002066" 
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img src="../assets/icon/备案图标.png" style="float:left;"/>
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">
            <font size="1.5"><small :class="{ 'moon-tag': !isStandard, 'sunny-tag': isStandard }">浙公网安备 33030202002066号</small></font></p>
        </a>
      </div>
    </div>

  </div>
</template>

<script>
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?e7d4e46f2b36cd0872453a949d6bcd81";
    var s = document.getElementsByTagName("script")[0]; 
    s.parentNode.insertBefore(hm, s);
  })();
  /* eslint-disable */
  import {
    getAllData,
    getDataByKeywords,
    getDataArea,
    getDataLevel,
    getDataByLocationAndProtected
  } from "@/api/data-manage";
  import AMapLoader from "@amap/amap-jsapi-loader";
  // 高德js密钥
  window._AMapSecurityConfig = {
    securityJsCode: "2bc527ce9787f9dce7e79e5a45a324ff",
  };
  import axios from "axios";
  import QRCode from 'qrcode';
  import { register, login, getUserInfo, getFavorites, addFavorite, removeFavorite } from '@/api/user-manage';

  // js主体部分
  export default {
    data() {
      return {
        tempMarker: null,
        option:['简介','画廊'],
        currentIndex: 0,
        levelList: [
        { id: 1, path: require('../assets/icon/country.png'), isChecked: true, des: '全国重点文物保护单位' },
        { id: 2, path: require('../assets/icon/province.png'), isChecked: true, des: '省级文物保护单位' },
        { id: 3, path: require('../assets/icon/city.png'), isChecked: true, des: '县市级文物保护单位' },
        { id: 4, path: require('../assets/icon/other.png'), isChecked: true, des: '未知' },
      ],
        imgList: [{
            path: require("../assets/images/hualang/苏巴什佛寺遗址.png")
          },
        ], //画廊
        defaultImg: require("../assets/images/默认遗址图.jpg"), //默认图片
        imagepath: {
          zp_path: require("../assets/images/prop/prop_zp.png"),
        },
        selectedIndex: 0,
        keywords: "",
        searchHistory: [],
        showSearchHistory: false,
        autoCompleteList: [],
        showAutoComplete: false,
        searchTimer: null,
        items: [],
        allItems: [],
        areaList: ["全部"],
        protectedList: ["全部"],
        queryBox: {
          area: "",
          protected: "",
          type: 0,
        },
        activeIndex: -1,
        // 默认深浅度开关
        isStandard: true,
        markers: [],
        labels: [],
        layer: undefined,
        isOpen: false,
        autoplay: false,
        tempData: {},
        tempImg: {},
        allCity: [],
        allPolygon: [],
        isOpenPolygon: true,
        isResultsVisible: true,
        currentPage: 1,
        pageSize: 20,
        showGuide: false,
        initialCenter: [98.14674, 38.291732],
        initialZoom: 4.45,
        // 用户相关
        isLoggedIn: false,
        currentUser: null,
        showLoginDialog: false,
        showRegisterDialog: false,
        loginForm: {
          username: '',
          password: ''
        },
        registerForm: {
          username: '',
          password: '',
          confirmPassword: '',
          email: ''
        },
        // 收藏相关
        favorites: [],
        showFavoritesDialog: false,
        // 分享相关
        showShareDialog: false,
        shareUrl: '',
        qrcodeUrl: '',
        shareData: null
      };
    },
    // 一直监测，执行
    computed: {
      // 筛选数据
      filteredData() {
        this.items.forEach((item) => {
          var starttime =
            item.start_time == null ? 0 : item.start_time.toString();
          var endtime = item.end_time == null ? 0 : item.end_time.toString();
          var timestr = '约' + starttime + '万年前';

          if (endtime == 0) {
            timestr = timestr
          } else {
            timestr = timestr + ' 至 ' + endtime + '万年前';
          }
          if (starttime.length > 6) {
            timestr = starttime + '至' + endtime;
          }
          if (starttime == 0) {
            timestr = '不详';
          }
          if (starttime == '无') {
            timestr = '不详';
          }
          item['time'] = timestr
        });
        const selectedButton = this.levelList
          .filter((item) => item.isChecked)
          .map((item) => item.id);
        if (selectedButton.length === this.levelList.length) {
          // 如果全部选中，返回所有项目。
          return this.items;
        } else {
          return this.items.filter(
            (item) => selectedButton.indexOf(item.protected_level_code) != -1
          );
        }
      },
      // 分页后的数据
      paginatedData() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.filteredData.slice(start, end);
      },
      // 总页数
      totalPages() {
        return Math.ceil(this.filteredData.length / this.pageSize);
      },
      // 显示结果计数（用于动画）
      displayCount() {
        return this.filteredData.length;
      }
    },
    // 监听是否发生变化
    watch: {
      levelList: {
        handler(newVal, oldVal) {
          const selectedButton = this.levelList
            .filter((item) => item.isChecked)
            .map((item) => item.id);
          this.refreshMarkers(selectedButton);
        },
        deep: true,
      },
    },
    // 初始执行
    mounted() {
      this.getRegion();
      this.getAllData();
      this.getDataArea();
      this.getDataProtected();
      this.loadSearchHistory();
      this.checkFirstVisit();
      this.loadUserState();
      this.loadFavorites();
    },
    methods: {
      changeIndex(index) {
        // console.log(index);
        this.currentIndex = index
        
        // this.map.setCenter(this.tempMarker.getPosition(), true);//打开或者关闭
        this.map.setCenter(this.map.getPosition(), true);//打开或者关闭
      },
      getRegion() {
        let citys = ['北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省',
                    '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区',
                    '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区',
                    '新疆维吾尔自治区', '台湾省', '香港特别行政区', '澳门特别行政区'];
        let tmpdata = []
        citys.forEach((item,index) => {
          let url = 'data/全国/' + item + '.txt';
          axios({
            method: "get",
            url: url
          }).then((res) => {
            let data = res.data

            let arr = [];
            let positions = data.split(';')
            positions.forEach(items=>{
              let points = items.split(',')
              let p = [points[0],points[1]]
              arr.push(p)
            })
            this.allCity[index] = [arr]
          }).catch({});
        })
      },
      addPolygon(){
          // console.log(this.allPolygon[0])
          if(this.allPolygon.length){
            this.allPolygon.forEach(item=>{
              if(this.isOpenPolygon){
                item.hide()
              }else{
                item.show()
              }
            })
          }else{
          let bgColor = ['#A9A9A9', '#D2691E', '#8FBC8F', '#AFEEEE', '#93DB70', '#2E8B57', '#DBDB70', '#DAA520', '#F0FFF0', '#00FF7F',
                      '#87CEFA', '#FFE4C4', '#D3D3D3', '#DB7093', '#00BFFF', '#F5F5F5', '#FA8072', '#93DB70', '#FFE4C4', '#00FFFF',
                      '#191970', '#48D1CC', '#FFE4C4', '#CD5C5C', '#E9C2A6', '#D8D8BF', '#DB70DB', '#EBC79E', '#1E90FF', '#9999FF',
                      '#AFEEEE', '#FF6699', '#DEB887', '#7FFF00'];
            this.allCity.forEach((item,index)=>{
              let polygon = new AMap.Polygon({
                path: item,
                fillColor: bgColor[index],
                strokeOpacity: 1,
                // 涂层透明度
                fillOpacity: 0.9,
                // strokeColor: '#ffff00',
                strokeColor: '#0099FF',
                strokeWeight: 1,
                strokeStyle: 'soild',
                strokeDasharray: [5, 5],
              });
              if(this.isOpenPolygon){
                polygon.hide()
              }else{
                polygon.show()
              }

              this.map.add(polygon);
              this.allPolygon.push(polygon)
            })
          }
      },
      selectTab(index) {
        this.selectedIndex = index;
      },
      selectOne(item) {
        var index = this.filteredData.indexOf(item);
        console.log(index);
        var marker = this.markers[index];
        marker.emit("click", {
          target: marker
        });
      },
      selectItem(id) {
        if (id == 1) {
          this.queryBox.type = 1;
          this.queryBox.protected = "";
        }

        if (id == 2) {
          this.queryBox.type = 2;
          this.queryBox.area = "";
        }
        getDataByLocationAndProtected(this.queryBox).then((res) => {
          this.items = res.data;
          console.log('this.items', this.items);
          this.markers = [];
          this.labels = [];
          this.layer = undefined;
          if (id == 1) {
            // console.log(this.queryBox);
            if (this.queryBox.area == "全部") {
              this.initMap()
            } else {
              // 行政区划zoom参数
              this.initMap(6, this.items[0].lng, this.items[0].lat);
            }
          } else if (id == 2) {
            this.initMap()
          }
        });
      },
      // 获取所有点数据
      getAllData() {
        getAllData()
          .then((res) => {
            this.items = res.data;
            this.allItems = res.data; // 保存所有数据用于自动补全
            this.currentPage = 1; // 重置页码
            this.initMap();
          })
          .catch({});
      },
      // 获取行政区选择
      getDataArea() {
        getDataArea()
          .then((res) => {
            res.data.forEach((item) => {
              this.areaList.push(item.location);
            });
          })
          .catch({});
      },
      getDataProtected() {
        let country = []
        let province = []
        let city = []
        let other = []
        getDataLevel()
          .then((res) => {
            res.data.forEach((item) => {
              if (
                typeof item.protected_level !== "undefined" &&
                item.protected_level != null &&
                item.protected_level !== ""
              ) {
                let list = item.protected_level
                if(list.indexOf('国家') != -1){
                  // this.protectedList.push(item.protected_level);
                  country.push(list)
                }else if(list.indexOf('省') != -1){
                  province.push(list)
                }else if(list.indexOf('市') != -1){
                  city.push(list)
                }else{
                  other.push(list)
                }

              }
            });
            let sortCountry = [];
            sortCountry.push(country[6],country[7],country[4],country[1],country[0],country[2],country[3],country[5])
            this.protectedList.push(...sortCountry,...province,...city,...other)
            // console.log(this.protectedList);
          })
          .catch({});


          
      },
      // 搜索框输入监听（自动补全）
      onSearchInput() {
        this.showSearchHistory = false;
        if (this.keywords.trim()) {
          // 防抖搜索
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => {
            this.fetchAutoComplete();
          }, 300);
        } else {
          this.showAutoComplete = false;
          this.autoCompleteList = [];
        }
      },
      // 获取自动补全建议
      fetchAutoComplete() {
        if (!this.keywords.trim()) {
          this.showAutoComplete = false;
          return;
        }
        // 从所有数据中筛选匹配的遗址名称
        const keyword = this.keywords.toLowerCase();
        this.autoCompleteList = this.allItems
          .filter(item => 
            item.name && item.name.toLowerCase().includes(keyword)
          )
          .slice(0, 10)
          .map(item => ({
            name: item.name,
            address: item.address
          }));
        this.showAutoComplete = this.autoCompleteList.length > 0;
      },
      // 选择自动补全项
      selectAutoComplete(item) {
        this.keywords = item.name;
        this.showAutoComplete = false;
        this.getDataByKeywords();
      },
      // 清空搜索框
      clearSearch() {
        this.keywords = '';
        this.showAutoComplete = false;
        this.showSearchHistory = false;
        this.getAllData();
      },
      // 显示搜索历史
      showHistory() {
        if (!this.keywords.trim() && this.searchHistory.length > 0) {
          this.showSearchHistory = true;
          this.showAutoComplete = false;
        }
      },
      // 选择搜索历史
      selectHistory(keyword) {
        this.keywords = keyword;
        this.showSearchHistory = false;
        this.getDataByKeywords();
      },
      // 删除搜索历史项
      removeHistory(index) {
        this.searchHistory.splice(index, 1);
        this.saveSearchHistory();
      },
      // 清空所有搜索历史
      clearHistory() {
        this.searchHistory = [];
        this.showSearchHistory = false;
        localStorage.removeItem('searchHistory');
      },
      // 保存搜索历史到localStorage
      saveSearchHistory() {
        localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));
      },
      // 从localStorage加载搜索历史
      loadSearchHistory() {
        const history = localStorage.getItem('searchHistory');
        if (history) {
          this.searchHistory = JSON.parse(history);
        }
      },
      // 搜索方法
      getDataByKeywords() {
        if (!this.keywords.trim()) {
          this.getAllData();
          return;
        }
        
        // 保存到搜索历史
        const keyword = this.keywords.trim();
        if (keyword && !this.searchHistory.includes(keyword)) {
          this.searchHistory.unshift(keyword);
          if (this.searchHistory.length > 10) {
            this.searchHistory.pop();
          }
          this.saveSearchHistory();
        }
        
        this.showAutoComplete = false;
        this.showSearchHistory = false;
        this.currentPage = 1; // 重置到第一页
        
        getDataByKeywords({
            keywords: keyword
          })
          .then((res) => {
            this.items = res.data;
            this.markers = [];
            this.labels = [];
            this.layer = undefined;
            this.initMap();
          })
          .catch({});
      },
      // 分页相关方法
      changePage(page) {
        if (page < 1 || page > this.totalPages) return;
        this.currentPage = page;
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
        }
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
        }
      },
      // 地图控制方法
      resetMapView() {
        if (this.map) {
          this.map.setZoomAndCenter(this.initialZoom, this.initialCenter);
        }
      },
      toggleFullscreen() {
        const elem = document.getElementById('map-container');
        if (!document.fullscreenElement) {
          elem.requestFullscreen().catch(err => {
            console.log(`Error attempting to enable full-screen: ${err.message}`);
          });
        } else {
          document.exitFullscreen();
        }
      },
      zoomIn() {
        if (this.map) {
          this.map.zoomIn();
        }
      },
      zoomOut() {
        if (this.map) {
          this.map.zoomOut();
        }
      },
      // 首次访问引导
      checkFirstVisit() {
        const hasVisited = localStorage.getItem('hasVisited');
        if (!hasVisited) {
          this.showGuide = true;
        }
      },
      closeGuide() {
        this.showGuide = false;
        localStorage.setItem('hasVisited', 'true');
      },
      // ========== 用户功能 ==========
      // 加载用户状态
      loadUserState() {
        const token = localStorage.getItem('access_token');
        if (token) {
          // 如果token存在，获取用户信息
          getUserInfo()
            .then(res => {
              if (res.data.success) {
                this.currentUser = res.data.data;
                this.isLoggedIn = true;
                this.loadFavorites();
              }
            })
            .catch(err => {
              // token失效，清除登录状态
              localStorage.removeItem('access_token');
              this.isLoggedIn = false;
              this.currentUser = null;
            });
        }
      },
      // 显示登录对话框
      openLoginDialog() {
        this.showLoginDialog = true;
        this.loginForm = { username: '', password: '' };
      },
      // 登录
      handleLogin() {
        if (!this.loginForm.username || !this.loginForm.password) {
          this.$message.warning('请输入用户名和密码');
          return;
        }
        
        login(this.loginForm)
          .then(res => {
            if (res.data.success) {
              // 保存token
              localStorage.setItem('access_token', res.data.data.token);
              this.currentUser = res.data.data.user;
              this.isLoggedIn = true;
              this.showLoginDialog = false;
              this.$message.success('登录成功！');
              this.loadFavorites();
            } else {
              this.$message.error(res.data.message || '登录失败');
            }
          })
          .catch(err => {
            const msg = err.response?.data?.message || '登录失败，请检查网络';
            this.$message.error(msg);
          });
      },
      // 显示注册对话框
      openRegisterDialog() {
        this.showLoginDialog = false;
        this.showRegisterDialog = true;
        this.registerForm = { username: '', password: '', confirmPassword: '', email: '' };
      },
      // 注册
      handleRegister() {
        if (!this.registerForm.username || !this.registerForm.password) {
          this.$message.warning('请填写完整信息');
          return;
        }
        if (this.registerForm.password !== this.registerForm.confirmPassword) {
          this.$message.error('两次密码输入不一致');
          return;
        }
        
        register({
          username: this.registerForm.username,
          password: this.registerForm.password,
          email: this.registerForm.email
        })
          .then(res => {
            if (res.data.success) {
              this.$message.success('注册成功！请登录');
              this.showRegisterDialog = false;
              this.showLoginDialog = true;
            } else {
              this.$message.error(res.data.message || '注册失败');
            }
          })
          .catch(err => {
            const msg = err.response?.data?.message || '注册失败，请检查网络';
            this.$message.error(msg);
          });
      },
      // 退出登录
      handleLogout() {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.currentUser = null;
          this.isLoggedIn = false;
          localStorage.removeItem('access_token');
          this.favorites = [];
          this.$message.success('已退出登录');
        }).catch(() => {});
      },
      // 处理用户下拉菜单命令
      handleUserCommand(command) {
        if (command === 'favorites') {
          this.showFavorites();
        } else if (command === 'logout') {
          this.handleLogout();
        }
      },
      
      // ========== 收藏功能 ==========
      // 加载收藏列表
      loadFavorites() {
        if (!this.isLoggedIn) {
          this.favorites = [];
          return;
        }
        
        getFavorites()
          .then(res => {
            if (res.data.success) {
              // 转换后端字段到前端格式
              this.favorites = res.data.data.map(fav => ({
                id: fav.relic_id,
                name: fav.relic_name,
                address: fav.relic_address,
                time: fav.relic_time,
                protected_level: fav.relic_protected_level,
                lng: fav.relic_lng,
                lat: fav.relic_lat
              }));
            }
          })
          .catch(err => {
            console.error('加载收藏失败:', err);
          });
      },
      // 检查是否已收藏
      isFavorite(item) {
        return this.favorites.some(fav => fav.id === item.id);
      },
      // 切换收藏状态
      toggleFavorite(item) {
        if (!this.isLoggedIn) {
          this.$message.warning('请先登录后再收藏');
          this.openLoginDialog();
          return;
        }
        
        const isFav = this.isFavorite(item);
        
        if (isFav) {
          // 取消收藏
          removeFavorite(item.id)
            .then(res => {
              if (res.data.success) {
                const index = this.favorites.findIndex(fav => fav.id === item.id);
                if (index > -1) {
                  this.favorites.splice(index, 1);
                }
                this.$message.success('已取消收藏');
              }
            })
            .catch(err => {
              this.$message.error('取消收藏失败');
            });
        } else {
          // 添加收藏
          addFavorite(item)
            .then(res => {
              if (res.data.success) {
                this.favorites.push({
                  id: item.id,
                  name: item.name,
                  address: item.address,
                  time: item.time,
                  protected_level: item.protected_level,
                  lng: item.lng,
                  lat: item.lat
                });
                this.$message.success('收藏成功');
              }
            })
            .catch(err => {
              const msg = err.response?.data?.message || '收藏失败';
              this.$message.error(msg);
            });
        }
      },
      // 显示收藏列表
      showFavorites() {
        if (!this.isLoggedIn) {
          this.$message.warning('请先登录');
          this.openLoginDialog();
          return;
        }
        this.showFavoritesDialog = true;
      },
      // 从收藏列表中选择遗址
      selectFavorite(item) {
        this.showFavoritesDialog = false;
        // 在地图上定位到该遗址
        if (this.map) {
          this.map.setZoomAndCenter(10, [item.lng, item.lat]);
          // 触发标记点击
          const marker = this.markers.find(m => 
            m.getPosition().lng === item.lng && m.getPosition().lat === item.lat
          );
          if (marker) {
            marker.emit('click', { target: marker });
          }
        }
      },
      // 删除收藏（从收藏列表中删除）
      removeFavoriteFromList(item) {
        removeFavorite(item.id)
          .then(res => {
            if (res.data.success) {
              const index = this.favorites.findIndex(fav => fav.id === item.id);
              if (index > -1) {
                this.favorites.splice(index, 1);
              }
              this.$message.success('已删除收藏');
            }
          })
          .catch(err => {
            this.$message.error('删除收藏失败');
          });
      },
      
      // ========== 分享功能 ==========
      // 分享遗址
      async shareRelic(item) {
        this.shareData = item;
        // 生成分享链接（包含遗址ID或经纬度）
        const baseUrl = window.location.origin + window.location.pathname;
        this.shareUrl = `${baseUrl}?id=${item.id}&lng=${item.lng}&lat=${item.lat}`;
        
        // 生成二维码
        try {
          this.qrcodeUrl = await QRCode.toDataURL(this.shareUrl, {
            width: 200,
            margin: 1
          });
        } catch (error) {
          console.error('生成二维码失败:', error);
        }
        
        this.showShareDialog = true;
      },
      // 复制分享链接
      copyShareLink() {
        const input = document.createElement('input');
        input.value = this.shareUrl;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message.success('链接已复制到剪贴板');
      },
      // 下载二维码
      downloadQRCode() {
        const link = document.createElement('a');
        link.download = `${this.shareData.name}_二维码.png`;
        link.href = this.qrcodeUrl;
        link.click();
        this.$message.success('二维码已下载');
      },

      // 地图初始化
      initMap(zoom, x, y) {
        AMapLoader.load({
            key: "5997521b77691ab6a986bacf2258dbf7", // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: ["AMap.DistrictSearch", "AMap.PlaceSearch"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
          })
          .then((AMap) => {
            this.map = new AMap.Map("map-container", {
              //设置地图容器id
              zoom: zoom ? zoom : 4.45, //初始化地图级别
              viewMode: "3D", // 地图设置成 3D 模式，否则图层会失去高度信息
              center: (x && y) ? [x, y] : [98.14674, 38.291732], //初始化地图中心点位置
              // center: [103.14674, 39.291732], //初始化地图中心点位置
              resizeEnable: true,
              mapStyle: this.isStandard ?
                "amap://styles/normal" : "amap://styles/blue",
              // normal （标准）、dark（幻影黑）、light（ 月光银）、whitesmoke（远山黛）、fresh（草色青）、grey（雅士灰）、graffiti（涂鸦）、macaron（马卡龙）、blue（靛青蓝）、darkblue（极夜蓝）、wine（酱籽）
            });

            this.layer = new AMap.LabelsLayer({
              zooms: [0, 30],
              zIndex: 1000,
              // collision: false,
              // 设置 allowCollision：true，可以让标注避让用户的标注
              allowCollision: true,
            });
            this.layer.add(this.labels);
            // 图层添加到地图
            this.map.add(this.layer);
            // 创建一个 Icon
            let startIcon = new AMap.Icon({
              // 图标尺寸
              size: new AMap.Size(30, 30),
              // 图标的取图地址
              // image: require('../assets/icon/country.png'),
              // 图标所用图片大小
              imageSize: new AMap.Size(30, 30),
              // // 图标取图偏移量
              imageOffset: new AMap.Pixel(0, 0),
            });
            // 标签文字
            var textStyle = {
              fontSize: 12,
              fontWeight: "normal",
              fillColor: "#FFCC33",
              // #
              // 797979
              strokeColor: "#003300",
              strokeWidth: 1,
              fontSize: 12,
              // fold: true,
            };
            // 标记点信息窗口
            let infoWindow = new AMap.InfoWindow({
              offset: new AMap.Pixel(15, 0),
              closeWhenClickMap: true,
              isCustom: true,
              avoid: [100, 100, 100, 100],
            });
            if(!this.tempInfoWin){
              this.tempInfoWin = infoWindow
            }
            for (var i = 0; i < this.items.length; i++) {
              let curData = this.items[i];
              curData.extData = {
                index: i,
              };
              let labelMarker = new AMap.LabelMarker({
                name: curData.name,
                position: [curData.lng, curData.lat],
                zooms: [0, 20],
                opacity: 1,
                zIndex: 1000,
                text: {
                  content: curData.name,
                  direction: "bottom",
                  offset: [15, 18],
                  style: textStyle,
                },
              });
              this.labels.push(labelMarker);

              let level = this.items[i].protected_level_code;
              // console.log('level',level);
              if (level == 1) {
                startIcon.setImage(this.levelList[0].path)
                startIcon.setSize([23, 23])
                startIcon.setImageSize([23, 23])
              }
              else if (level == 2) {
                startIcon.setImage(this.levelList[1].path)
                startIcon.setSize([19, 19])
                startIcon.setImageSize([19, 19])
              }
              else if (level == 3) {
                startIcon.setImage(this.levelList[2].path)
                startIcon.setSize([16, 16])
                startIcon.setImageSize([16, 16])
              }
              else if (level == 4) {
                startIcon.setImage(this.levelList[3].path)
                startIcon.setSize([15, 15])
                startIcon.setImageSize([15, 15])
              }
              let marker = new AMap.Marker({
                level: level,
                zIndex: 100 - level,
                position: [this.items[i].lng, this.items[i].lat],
                icon: startIcon,
                map: this.map,
              });

              // 远景图
              if (curData.far_image !== null) {
                let path = require("../assets/images/" +
                  curData.far_image +
                  ".png");
                curData.path = path;
              }
              // 其他图片
              let imgHtmlArr = [];
              if (curData.img_name) {
                let imgArr = curData.img_name.split(";");
                imgArr.forEach((img) => {
                  let path = require("../assets/images/hualang/" + img + ".png");
                  let list = {
                    path: path
                  }
                  imgHtmlArr.push(list)
                });
              }
              // console.log('imgHtmlArr',imgHtmlArr)
              curData.imgHualang = imgHtmlArr.length ? imgHtmlArr :this.imgList
              this.tempImg.prop_name = require("../assets/images/prop/prop_name.png");
              this.tempImg.prop_year = require("../assets/images/prop/石器.png");
              this.tempImg.prop_wb = require("../assets/images/prop/prop_wb.png");
              this.tempImg.prop_location = require("../assets/images/prop/prop_location.png");
              this.tempImg.prop_m = require("../assets/images/prop/地位.png");
              this.tempImg.prop_xz = require("../assets/images/prop/详情.png");
              this.tempImg.prop_jj = require("../assets/images/prop/竖条.png");

              marker.on("click", () => {
                this.tempMarker = marker
                this.tempData = curData;
                let info = this.$refs["gallery"];

                this.map.setCenter(marker.getPosition(), true);
                infoWindow.setContent(info);
                infoWindow.open(this.map, marker.getPosition());
              });
              this.markers.push(marker);
              // marker.emit('click', { target: marker });
            }
            this.layer.add(this.labels);
            this.allPolygon = []
            this.addPolygon()
            // this.map.setFitView();
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            if (this.keywords !== "" && this.markers.length > 0) {
              this.activeIndex = 0;
              var marker = this.markers[0];
              marker.emit("click", {
                target: marker
              });
              // this.map.setCenter(marker.getCenter(), true)
            }
          });
      },

      setStandardStyle() {
        this.isStandard = true;
        this.map.setMapStyle("amap://styles/normal");
      },
      setDarkStyle() {
        this.isStandard = false;
        this.map.setMapStyle("amap://styles/blue");
        //  this.getAllData();
      },
      setPolygonStyle() {
        this.isOpenPolygon = !this.isOpenPolygon
        this.addPolygon()
      },

      refreshMarkers(selectedButton) {
        this.markers.forEach((marker, index) => {
          if (selectedButton.indexOf(marker._opts.level) == -1) {
            marker.setMap(null);
            this.labels[index].setVisible(false);
          } else {
            marker.setMap(this.map);
            this.labels[index].setVisible(true);
          }
        });
      },
    },
  };
</script>

<style scoped>
  .tabs {
    position: absolute;
    top: 20px;
    left: 0px;
    right: 0px;
    z-index: 10;
  }

  .tabs img {
    height: 35px;
    display: inline-block;
    vertical-align: middle;
  }

  .selected-tab {
    filter: brightness(0);
  }

  .container {
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 100%;
  }

  #map-container {
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .map-style-switcher {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 999;
  }
  .polygon-style-switcher {
      position: absolute;
      top: 80px;
      right: 30px;
      z-index: 999;
  }
  .umbrella-style-switcher {
      position: absolute;
      top: 130px;
      right: 30px;
      z-index: 999;
  }
  .bg-xiang{
    background: url('../assets/light/文物链.png');
    background-size: 100% 100%;
    border: 0;
    border-radius: 50%;
    overflow: hidden;
  }
  .bg-wen{
    background: url('../assets/light/文物链.png');
    background-size: 100% 100%;
    border: 0;
    border-radius: 50%;
    overflow: hidden;
  }

  .bg-kai{
    background: url('../assets/light/钻石.png');
    background-size: 100% 100%;
    border: 0;
    border-radius: 50%;
    overflow: hidden;
  }
  .bg-guan{
    background: url('../assets/light/钻石.png');
    background-size: 100% 100%;
    border: 0;
    border-radius: 50%;
    overflow: hidden;
  }
  .bg-zhang{
    background: url('../assets/light/伞.png');
    background-size: 100% 100%;
    border: 0;
    border-radius: 50%;
    overflow: hidden;
  }
  .bg-han{
    background: url('../assets/light/伞.png');
    background-size: 100% 100%;
    border: 0;
    border-radius: 50%;
    overflow: hidden;
  }
  .area {
    position: fixed;
    bottom: 200px;
    right: 10px;
    z-index: 1;
    text-align: left;
    color: rgb(39, 39, 39);
    font-family: "Helvetica Neue", Arial, sans-serif;
    font-weight: bold;
    line-height: 25px;
  }

  .selectdiv {
    background-color: #999;
  }

  .protected {
    position: fixed;
    bottom: 270px;
    right: 10px;
    z-index: 1;
    text-align: left;
    color: rgb(41, 41, 41);
    font-family: "Helvetica Neue", Arial, sans-serif;
    font-weight: bold;
    line-height: 25px;
  }

  .level {
    font-family: 'STKaiti';
    position: fixed;
    bottom: 10px;
    right: 10px;
    z-index: 1;
    text-align: left;
    color: white;
  }

  .level-img {
    display: inline-block;
    vertical-align: middle;
    /* margin-right: 5px; */
    padding: 3px 5px;
  }

  .moon-tag {
    font-family: 'STKaiti';
    display: inline-block;
    color: white;
    font-size: 14px;
    font-family: "Helvetica Neue", Arial, sans-serif;
    font-weight: bold;
  }

  .sunny-tag {
    font-family: 'STKaiti';
    display: inline-block;
    color: black;
    font-size: 14px;
    font-family: "Helvetica Neue", Arial, sans-serif;
    font-weight: bold;
  }

  .isSelected {
    /* 灰度 */
    filter: grayscale(0%);
  }

  .unSelected {
    /* 灰度 */
    filter: grayscale(100%);
  }

  .search-group {
    width: 300px;
    position: fixed;
    left: 100px;
    top: 30px;
    /* height: 100%; */
    z-index: 999;
  }

  .title-container {
    display: flex;
    color: rgb(224, 224, 224);
    align-items: center;
  }

  .moon-title {
    margin-right: auto;
    color: white;
    /* 将标题推向左侧 */
  }

  .sunny-title {
    margin-right: auto;
    color: black;
    /* 将标题推向左侧 */
  }

  .icon {
    position: fixed;
    left: 420px;
    top: 35px;
  }

  .data-group {
    background-color: #f5f5f5;
    margin-top: 20px;
    padding-top: 5px;
    border-radius: 5px;
    box-shadow: 1px 1px 10px #ccc;
  }

  .result-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 15px;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
  }

  .result-header:hover {
    background-color: #e8e8e8;
  }

  .toggle-icon {
    font-size: 16px;
    color: #666;
    transition: transform 0.3s;
  }

  .list {
    max-height: 500px;
    overflow-y: auto;
    margin-top: 0px;
  }

  .item {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgb(225, 225, 225);
    transition: background-color 0.2s;
  }

  .item:hover {
    background-color: #dbe4dd;
  }

  .item.active {
    background-color: rgb(126, 198, 206);
    color: white;
    border-bottom: 0px solid gray;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: left;
    cursor: pointer;
  }
  
  .item-actions {
    display: flex;
    gap: 5px;
    flex-shrink: 0;
  }

  .name {
    font-size: 16px;
    font-weight: bold;
  }

  .title-img {
    position: fixed;
    left: 80px;
    top: 18px;
    z-index: 1;
  }

  ::v-deep .left_fix {
    width: 20px;
    margin-right: 5px;
  }

  .gallery {
    width: 340px;
    border-radius: 5px;
    overflow: hidden;
    /* overflow-y: auto; */
    background: #fff;
  }
  .select{
    margin: 10px 0;
    border: 1px solid #556da4;
    display: flex;
  }
  .gallery .btn{
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 14px;
    background: #fff;
    text-align: center;
  }
  .gallery .active{
    color: #fff;
    background: #556da4;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  ::v-deep .el-carousel__container {
    height: 600px;
  }

  ::v-deep .el-carousel__button {
    background: #ccc;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #fff;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #fff;
  }

  ::v-deep .el-image {
    width: 309px;
    height: 230px;
    margin: 5px;
    box-sizing: border-box;
  }

  /* ::v-deep .el-images-more {
    width: 110px;
    height: 110px;
    margin: 5px;
    box-sizing: border-box;
  } */

  /* ===== 新增功能样式 ===== */
  
  /* 搜索框包装器 */
  .search-input-wrapper {
    position: relative;
  }

  /* 搜索下拉框（历史和自动补全） */
  .search-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-top: 5px;
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 2000;
  }

  .dropdown-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    border-bottom: 1px solid #f0f0f0;
    font-weight: bold;
    font-size: 14px;
  }

  .dropdown-item {
    padding: 10px 15px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background-color 0.2s;
    border-bottom: 1px solid #f5f5f5;
  }

  .dropdown-item:hover {
    background-color: #f5f7fa;
  }

  .dropdown-item:last-child {
    border-bottom: none;
  }

  .history-text {
    flex: 1;
    color: #606266;
  }

  .history-text i {
    margin-right: 8px;
    color: #909399;
  }

  .dropdown-item .el-icon-close {
    color: #c0c4cc;
    font-size: 14px;
  }

  .dropdown-item .el-icon-close:hover {
    color: #f56c6c;
  }

  .autocomplete-name {
    font-weight: bold;
    margin-bottom: 3px;
  }

  .autocomplete-addr {
    color: #909399;
    font-size: 12px;
  }

  /* 空状态 */
  .empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #909399;
  }

  .empty-icon {
    font-size: 64px;
    color: #dcdfe6;
    margin-bottom: 16px;
  }

  .empty-state p {
    font-size: 16px;
    margin: 10px 0;
    color: #606266;
  }

  /* 分页控件 */
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    gap: 10px;
    border-top: 1px solid #eee;
  }

  .page-info {
    font-size: 14px;
    color: #606266;
    min-width: 60px;
    text-align: center;
  }

  /* 结果计数动画 */
  .result-count {
    display: inline-block;
    animation: countFadeIn 0.5s ease;
  }

  @keyframes countFadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* 地图控制按钮位置 */
  .map-controls {
    position: absolute;
    top: 180px;
    right: 30px;
    z-index: 999;
  }

  .map-zoom-controls {
    position: absolute;
    top: 230px;
    right: 30px;
    z-index: 999;
  }

  .map-zoomout-controls {
    position: absolute;
    top: 275px;
    right: 30px;
    z-index: 999;
  }

  .map-fullscreen-controls {
    position: absolute;
    top: 320px;
    right: 30px;
    z-index: 999;
  }

  /* 引导弹窗内容 */
  .guide-content {
    text-align: left;
    line-height: 1.8;
  }

  .guide-content h3 {
    color: #409eff;
    margin-top: 15px;
    margin-bottom: 10px;
  }

  .guide-content ul {
    padding-left: 20px;
  }

  .guide-content li {
    margin-bottom: 10px;
  }

  .guide-content p {
    margin: 5px 0;
    color: #606266;
  }

  /* 响应式优化 */
  @media (max-width: 768px) {
    .search-group {
      width: 90%;
      left: 5%;
    }
    
    .search-dropdown {
      font-size: 14px;
    }
  }

  /* ===== 用户、收藏、分享功能样式 ===== */
  
  /* 用户操作区域 */
  .user-actions {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .user-info {
    text-align: left;
  }

  .user-dropdown {
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 4px;
    background-color: #f0f0f0;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: background-color 0.3s;
  }

  .user-dropdown:hover {
    background-color: #e0e0e0;
  }

  /* 收藏列表 */
  .favorites-list {
    max-height: 500px;
    overflow-y: auto;
  }

  .favorite-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
  }

  .favorite-item:hover {
    background-color: #f5f7fa;
  }

  .fav-info {
    flex: 1;
    cursor: pointer;
  }

  .fav-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
    color: #303133;
  }

  .fav-details {
    color: #909399;
    font-size: 14px;
  }

  .fav-actions {
    display: flex;
    gap: 10px;
  }

  /* 分享内容 */
  .share-content {
    text-align: center;
  }

  .share-content h3 {
    margin-top: 0;
    color: #303133;
  }

  .share-desc {
    color: #606266;
    margin-bottom: 20px;
  }

  .qrcode-container {
    margin: 20px 0;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 8px;
  }

  .qrcode-img {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    display: block;
  }

  .qrcode-container p {
    margin-top: 10px;
    color: #909399;
    font-size: 14px;
  }

  .share-link {
    margin: 20px 0;
  }

  .share-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 20px;
  }

  /* 对话框优化 */
  ::v-deep .el-dialog__header {
    background-color: #f5f7fa;
    padding: 15px 20px;
  }

  ::v-deep .el-dialog__title {
    font-weight: bold;
  }

  ::v-deep .el-dialog__body {
    padding: 20px;
  }
</style>
